import { render } from "./BaseSectionHeader.vue?vue&type=template&id=2d72e7be&scoped=true"
import script from "./BaseSectionHeader.vue?vue&type=script&lang=js"
export * from "./BaseSectionHeader.vue?vue&type=script&lang=js"

import "./BaseSectionHeader.vue?vue&type=style&index=0&id=2d72e7be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d72e7be"]])

export default __exports__